import { FALSE } from "constants/primitives";

import WidgetConfig from "helpers/init/WidgetConfig";
import isScannerApp from "helpers/isScannerApp";
import hasPrivacyOptOutSignal from "./hasPrivacyOptOutSignal";

/**
 * True when this visit must be treated as "all optional categories declined",
 * without showing the banner and regardless of earlier consent.
 *
 * Called from several entry points, so it stays synchronous and uncached -
 * the visitor can toggle the signal between page loads.
 */
const shouldUseEmptyConsent = (widgetConfig: WidgetConfig) => {
  // the site owner decides whether opt-out signals are honoured at all
  if (!widgetConfig.gpcAndDntEnabled) {
    return FALSE;
  }

  // when scanner app visits, it must run every script to catalogue cookies, so an
  // opt-out set in the crawler's own browser is not a visitor opt-out
  if (isScannerApp()) {
    return FALSE;
  }

  // when the visitor asked not to be tracked, act as if they declined every optional category
  return hasPrivacyOptOutSignal();
};

export default shouldUseEmptyConsent;
